/* eslint-disable */
import React from 'react'
import { useSearchParams } from 'react-router-dom';
import "./style.scss";

function DashboardExternal() {
    let [searchParams, setSearchParams] = useSearchParams();
    let queryParamValue = searchParams.get('url');
  
  return (
    <div className='iframe-container-dashboard'>
      <iframe
            src={queryParamValue}
            title="IFrame Example"
            width="100%"
            height="100%"
            className='iframe'
        />
    </div>
  )
}

export default DashboardExternal
